import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Employed, CategoryType } from '../Api/employedsApi/type';

type EmployedsState = {
  items: Employed[];
};

const initialState: EmployedsState = {
  items: [],
};

const employedsSlice = createSlice({
  name: 'employeds',
  initialState,
  reducers: {
    setEmployeds: (state, action: PayloadAction<Employed[]>) => {
      state.items = action.payload;
    },
    updateEmployedCategories: (
      state,
      action: PayloadAction<{ employedId: number; categories: CategoryType[] }>,
    ) => {
      const { employedId, categories } = action.payload;
      const employed = state.items.find((item) => item.id === employedId);
      if (employed) {
        employed.categories = categories;
      }
    },
  },
});

export const { setEmployeds, updateEmployedCategories } = employedsSlice.actions;
export default employedsSlice.reducer;
